export default [
	{
		elementType: 'geometry',
		stylers: [
			{
				color: '#f5f5f5'
			}
		]
	},
	{
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#616161'
			}
		]
	},
	{
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#f5f5f5'
			}
		]
	},
	{
		featureType: 'administrative.country',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#333333'
			}
		]
	},
	{
		featureType: 'administrative.land_parcel',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#bdbdbd'
			}
		]
	},
	{
		featureType: 'administrative.province',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#333333'
			}
		]
	},
	{
		featureType: 'landscape.natural.landcover',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#eeeeee'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'geometry',
		stylers: [
			{
				color: '#eeeeee'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#757575'
			}
		]
	},
	{
		featureType: 'poi.attraction',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi.government',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi.medical',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#e1dfdf'
			}
		]
	},
	{
		featureType: 'poi.medical',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'geometry',
		stylers: [
			{
				color: '#bae7c9'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#9e9e9e'
			}
		]
	},
	{
		featureType: 'poi.place_of_worship',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi.school',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi.sports_complex',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'geometry',
		stylers: [
			{
				color: '#ffffff'
			}
		]
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#d7d7d7'
			}
		]
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#757575'
			}
		]
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry',
		stylers: [
			{
				color: '#b0b0b0'
			}
		]
	},
	{
		featureType: 'road.highway',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#616161'
			}
		]
	},
	{
		featureType: 'road.local',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#d7d7d7'
			}
		]
	},
	{
		featureType: 'road.local',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#9e9e9e'
			}
		]
	},
	{
		featureType: 'transit.line',
		elementType: 'geometry',
		stylers: [
			{
				color: '#e5e5e5'
			}
		]
	},
	{
		featureType: 'transit.station',
		elementType: 'geometry',
		stylers: [
			{
				color: '#eeeeee'
			}
		]
	},
	{
		featureType: 'transit.station',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'water',
		stylers: [
			{
				color: '#b8cddf'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#6398ee'
			}
		]
	}
];
